import { GET_SERVICES, ADD_SERVICE } from "../actions/service.actions";

const initialState = [];

export default function serviceReducer(state = initialState, action) {
  switch (action.type) {
    case GET_SERVICES:
      return action.payload;
    case ADD_SERVICE:
      // Évite les doublons (findOrCreate côté serveur peut renvoyer un existant)
      if (state.some((s) => s.value === action.payload.value)) return state;
      return [...state, action.payload];
    default:
      return state;
  }
}
